module.exports = __webpack_public_path__ + "static/media/img_fenlei02.2ffb7e63.png";